$piterjs_link $mol_link
	sub /
		<= Button $mol_button_major
			title <= title
